import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    claimsAnalysisSelectedTagsFilter: [],
};

export const claimsAnalysisStore = createSlice({
    name: "claimsAnalysisStore",
    initialState,
    reducers: {
        loadClaimsAnalysisSelectedTagsFilterState: (state, action) => {
            state.claimsAnalysisSelectedTagsFilter = action.payload;
        },
        resetClaimsAnalysisStore: () => initialState,
    },
});
export const { loadClaimsAnalysisSelectedTagsFilterState, resetClaimsAnalysisStore } = claimsAnalysisStore.actions;

export default claimsAnalysisStore.reducer;
